export class Cliente {
  constructor({ clienteId, ativo, manutencao }) {
    this.clienteId = clienteId;
    this.ativo = ativo;
    this.manutencao = manutencao;
  }
}
